import React from "react";
import { Link } from "react-router-dom";
import Api from "../../servicios/api";
import Swal from 'sweetalert2';

class Editar extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      datosCargados: false,
      nombre: "",
      tipo: "",
      empleado: [],
      errores: []
    };
  }

  cambioValor = (e) => {
    const state = this.state.empleado;
    state[e.target.name] = e.target.value;
    this.setState({ empleado: state });
  };

  verificarError(elemento) {
    return this.state.errores.indexOf(elemento) !== -1;
  }

  enviarDatos = (e) => {
    e.preventDefault();
    console.log("Formulario Enviado...");
    let form = document.getElementById('form');
    let formData = new FormData(form);
    console.log(formData);

    fetch(Api + "UpEmpresas", {
      method: "POST",
      body: formData
    })
      .then(respuesta => respuesta.json())
      .then((datosRespuesta) => {
        console.log(datosRespuesta)
        Swal.fire(
          'Empresas!',
          datosRespuesta.msj,
          'success'
        )
        this.props.history.push("/MasterEmpresas");
      })
      .catch(console.log)
  }

  componentDidMount() {
    console.log(this.props.match.params.id);
    fetch(Api + "Empresas/" + this.props.match.params.id, {
      method: "GET",
      headers: new Headers({
        'Authorization': 'koala2021'
      }),
    })
      .then((respuesta) => respuesta.json())
      .then((datosRespuesta) => {
        console.log(datosRespuesta);
        document.getElementById('modalidad').value = datosRespuesta.modalidad;
        document.getElementById('plan').value = datosRespuesta.plan;
        this.setState({ datosCargados: true, empleado: datosRespuesta });
      })
      .catch(console.log);
  }

  render() {
    const { datosCargados, empleado } = this.state;
    if (!datosCargados) {
      var load = 'Cargando datos....';
    } else {
      var load = '';
    }
    return (
      <div>
        <div className="content-wrapper">
          <div className="content">
            <div className="container-fluid">
              <div className="card">
                <div className="card-header">Editar Empresas {load}</div>
                <div className="card-body">
                  <form onSubmit={this.enviarDatos} id="form">
                    <div className="row">
                      {/* Columna 1 */}
                      <div className="col-md-4">
                        <div className="form-group">
                          <label htmlFor="id">Id:</label>
                          <input
                            type="text"
                            name="id"
                            id="id"
                            value={empleado.id_empresa}
                            className="form-control form-control-sm"
                            onChange={this.cambioValor}
                            readOnly
                          />
                        </div>

                        <div className="form-group">
                          <label htmlFor="codigo">NIT:</label>
                          <input
                            type="text"
                            name="codigo"
                            id="codigo"
                            defaultValue={empleado.nit_emp}
                            className="form-control form-control-sm"
                            onChange={this.cambioValor}
                            required
                          />
                        </div>

                        <div className="form-group">
                          <label htmlFor="nombre">Nombre:</label>
                          <input
                            type="text"
                            name="nombre"
                            id="nombre"
                            defaultValue={empleado.nombre_emp}
                            className={((this.verificarError("error_nombre")) ? "is-invalid" : "") + " form-control form-control-sm"}
                            onChange={this.cambioValor}
                            required
                          />
                        </div>

                        <div className="form-group">
                          <label htmlFor="tipo">Rips:</label>
                          <input
                            type="text"
                            name="tipo"
                            id="tipo"
                            defaultValue={empleado.rips}
                            className={((this.verificarError("error_tipo")) ? "is-invalid" : "") + " form-control form-control-sm"}
                            onChange={this.cambioValor}
                            required
                          />
                        
                        </div>
                      </div>

                      {/* Columna 2 */}
                      <div className="col-md-4">
                        <div className="form-group">
                          <label htmlFor="cuenta">Teléfono:</label>
                          <input
                            type="text"
                            name="cuenta"
                            id="cuenta"
                            defaultValue={empleado.tel_oficina_emp}
                            className={((this.verificarError("error_forma")) ? "is-invalid" : "") + " form-control form-control-sm"}
                            onChange={this.cambioValor}
                            required
                          />
                         
                        </div>

                        <div className="form-group">
                          <label htmlFor="email">Email:</label>
                          <input
                            type="text"
                            name="email"
                            id="email"
                            defaultValue={empleado.email1_emp}
                            onChange={this.cambioValor}
                            className="form-control form-control-sm"
                          />
                        </div>

                        <div className="form-group">
                          <label htmlFor="cliente">Empresa con Convenio:</label>
                          <select
                            className={((this.verificarError("error_tipo")) ? "is-invalid" : "") + " form-select form-select-sm"}
                            name="cliente"
                            id="cliente"
                            defaultValue={empleado.cliente}
                            onChange={this.cambioValor}
                          >
                            <option value="Si">Si</option>
                            <option value="">No</option>
                          </select>
                          
                        </div>

                        <div className="form-group">
                          <label htmlFor="contrato">Número de Contrato:</label>
                          <input
                            type="text"
                            name="contrato"
                            id="contrato"
                            defaultValue={empleado.contrato}
                            className={((this.verificarError("error_forma")) ? "is-invalid" : "") + " form-control form-control-sm"}
                            onChange={this.cambioValor}
                            
                          />
                          
                        </div>
                      </div>

                      {/* Columna 3 */}
                      <div className="col-md-4">
                        <div className="form-group">
                          <label htmlFor="poliza">Número de Poliza:</label>
                          <input
                            type="text"
                            name="poliza"
                            id="poliza"
                            defaultValue={empleado.poliza}
                            className={((this.verificarError("error_forma")) ? "is-invalid" : "") + " form-control form-control-sm"}
                            onChange={this.cambioValor}
                           
                          />
                         
                        </div>

                        <div className="form-group">
                          <label htmlFor="modalidad">Modalidad de pago: {empleado.modalidad}</label>
                          <select
                            className={((this.verificarError("error_tipo")) ? "is-invalid" : "") + " form-select form-select-sm"}
                            name="modalidad"
                            id="modalidad"
                            defaultValue={empleado.modalidad}
                            onChange={this.cambioValor}
                          >
                            <option value="">Seleccione</option>
                            <option value="01">1. Pago individual por caso</option>
                            <option value="02">2. Pago global prospectivo</option>
                            <option value="03">3. Pago por capitación</option>
                            <option value="04">4. Pago por evento</option>
                            <option value="05">5. Otra modalidad</option>
                          </select>
                          
                        </div>

                        <div className="form-group">
                          <label htmlFor="plan">Plan de servicio:</label>
                          <select
                            className={((this.verificarError("error_tipo")) ? "is-invalid" : "") + " form-select form-select-sm"}
                            name="plan"
                            id="plan"
                            defaultValue={empleado.plan}
                            onChange={this.cambioValor}
                          >
                            <option value="">Seleccione</option>
                            <option value="01">Plan de beneficios en salud</option>
                            <option value="02">Presupuesto máximo</option>
                            <option value="03">Prima EPS / EOC</option>
                            <option value="04">Cobertura Póliza SOAT</option>
                            <option value="05">Cobertura ARL</option>
                            <option value="06">Cobertura ADRES</option>
                            <option value="07">Cobertura Salud Pública</option>
                            <option value="08">Cobertura entidad territorial</option>
                            <option value="09">Urgencias población migrante</option>
                            <option value="10">Plan complementario en salud</option>
                            <option value="11">Plan medicina prepagada</option>
                            <option value="12">Otras pólizas en salud</option>
                            <option value="13">Cobertura Régimen Especial</option>
                            <option value="14">Cobertura Fondo Nacional</option>
                            <option value="15">Particular</option>
                          </select>
                         
                        </div>
                      </div>
                    </div>

                    <div className="row mt-3">
                      <div className="col-12">
                        <div className="btn-group" role="group" aria-label="">
                          
                          <Link className="btn btn-danger btn-sm" to={"/MasterEmpresas"}>
                            Cancelar
                          </Link>
                        </div>
                      </div>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default Editar;